import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import DnsService from '../../services/DnsService'
import {
  openErrorNotification,
  openSuccessNotification,
} from '../../utils/openNotification'
import i18n from '../../lang'

const initialState = {
  isLoading: false,
  dnsList: { list: [], page: 1 },
}

export const getDnsList = createAsyncThunk(
  'dns/getDnsList',
  async ({ domainId, limit, page }, { rejectWithValue }) => {
    try {
      return await DnsService.getDnsList({ domainId, page, limit })
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const deleteDns = createAsyncThunk(
  'dns/deleteDns',
  async ({ id, domainId }, { rejectWithValue, dispatch }) => {
    try {
      const response = await DnsService.deleteDns(id)

      await dispatch(getDnsList({ domainId }))

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const createDns = createAsyncThunk(
  'dns/createDns',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await DnsService.createDns(data)

      await dispatch(getDnsList({ domainId: data?.domainId }))

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const updateDns = createAsyncThunk(
  'dns/updateDns',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await DnsService.updateDns(data)

      await dispatch(getDnsList({ domainId: response?.domain_id }))

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const dnsSlice = createSlice({
  name: 'dns',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getDnsList.pending, state => {
      state.isLoading = true
    })
    builder.addCase(getDnsList.fulfilled, (state, action) => {
      state.dnsList = action.payload
      state.isLoading = false
    })
    builder.addCase(deleteDns.fulfilled, () => {
      openSuccessNotification({
        key: 'deleteDns',
        message: i18n.t('message.delete.dns.success'),
      })
    })
    builder.addCase(deleteDns.rejected, (_, action) => {
      openErrorNotification({
        key: 'deleteDns',
        message: i18n.t(action.payload) || i18n.t('message.default.error'),
      })
    })
    builder.addCase(createDns.fulfilled, () => {
      openSuccessNotification({
        key: 'createDns',
        message: i18n.t('message.create.dns.success'),
      })
    })
    builder.addCase(createDns.rejected, (_, action) => {
      openErrorNotification({
        key: 'createDns',
        message: i18n.t(action.payload) || i18n.t('message.default.error'),
      })
    })
    builder.addCase(updateDns.fulfilled, () => {
      openSuccessNotification({
        key: 'updateDns',
        message: i18n.t('message.update.dns.success'),
      })
    })
    builder.addCase(updateDns.rejected, (_, action) => {
      openErrorNotification({
        key: 'updateDns',
        message: i18n.t(action.payload) || i18n.t('message.default.error'),
      })
    })
  },
})

export default dnsSlice.reducer
